import axios from 'axios';
import type { AxiosStatic } from 'axios';
import { API_BASE_URL } from '@/utils/constants';

export const setHeader = (axiosInstance: AxiosStatic, key: string, value: string) => {
  axiosInstance.defaults.headers.common[key] = value;
};

export const setToken = (axiosInstance: AxiosStatic, token?: string | null, type?: string) => {
  if (!type) {
    if (!token) return;
    axiosInstance.defaults.headers.common.authorization = token;
    return;
  }

  switch (type) {
    case 'Bearer':
      axiosInstance.defaults.headers.common.authorization = `Bearer ${token}`;
      break;
    default:
      break;
  }
};

export const setBaseUrl = (axiosInstance: AxiosStatic, url: string) => {
  axiosInstance.defaults.baseURL = url ?? API_BASE_URL;
};

export const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 1000,
});

export const $axios = axios;
export const $axiosInstance = axiosInstance;
